/** @jsx jsx */
import { jsx } from '@emotion/core';
import { gridSize, math } from '@atlaskit/theme';
export default ({ tokens, ...props }) => (jsx("span", Object.assign({ css: {
        color: tokens.requiredIndicator.textColor.rest,
        paddingLeft: `${math.multiply(gridSize, 0.25)}px;`,
    } }, props)));
//# sourceMappingURL=RequiredIndicator.js.map